import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { PostProductBody } from '@snootsvet/shared'

import { useViewerRegion } from '@/frontend/features/region/region-context'
import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Creates a product in the active region. */
export function useCreateProduct() {
  const api = useOsApi()
  const { region } = useViewerRegion()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (body: Omit<PostProductBody, 'region'>) => {
      const response = await api.post('/products', { body: { ...body, region } })
      if (!response.success) throw new Error(response.error.message)
      return response.data.product
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['products'] })
    },
  })
}
